import { useState, useEffect, useCallback } from 'react';

export interface SpotlightRect {
  top: number;
  left: number;
  width: number;
  height: number;
}

const PADDING = 8;

export function useSpotlightPosition(target: string | null): SpotlightRect | null {
  const [rect, setRect] = useState<SpotlightRect | null>(null);

  const measure = useCallback(() => {
    if (!target) {
      setRect(null);
      return;
    }
    const el = document.querySelector(`[data-tutorial="${target}"]`);
    if (!el) {
      setRect(null);
      return;
    }
    const r = el.getBoundingClientRect();
    setRect({
      top: r.top - PADDING,
      left: r.left - PADDING,
      width: r.width + PADDING * 2,
      height: r.height + PADDING * 2,
    });
  }, [target]);

  useEffect(() => {
    measure();

    if (!target) return;

    const el = document.querySelector(`[data-tutorial="${target}"]`);
    let observer: ResizeObserver | undefined;
    if (el) {
      observer = new ResizeObserver(measure);
      observer.observe(el);
    }

    window.addEventListener('resize', measure);
    window.addEventListener('scroll', measure, true);

    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
      window.removeEventListener('scroll', measure, true);
    };
  }, [target, measure]);

  return rect;
}
